import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import * as HTML_RENDITION from '../../../utils/general/general';
import $ from 'jquery';
import _, { isEqual } from 'lodash';
import { Base64 } from 'js-base64';
import * as environmentService from '../../../utils/general/environmentService';
import servicesConfig from '../../../services/servicesConfig';
import { switchPage } from '../../../utils/api/pageControl';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import commonStore from '../../../store/commonStore.js';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import ModalPopup from '../../../modalrelated/modalPopup';
import NormalScreenPopup from '../../../modalrelated/normalScreenPopup';
import { getCwStvTitle } from '../../../utils/general/general';

interface IMultiCompanyCatalystWatchProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    multiCompanyMetaData: any;
    loadCatalystWatchData: () => {};
    catalystWatchData: any;
    sectionData: any;
    htmlPDFtoggleStatus: boolean;
    menuCode: any;
}

export class MultiCompanyCatalystWatch extends Component<IMultiCompanyCatalystWatchProps, any> {
    constructor(props: IMultiCompanyCatalystWatchProps) {
        super(props);
        this.state = {
            modalStatus: false,
        };
    }

    public shouldComponentUpdate(nextProps: IMultiCompanyCatalystWatchProps, nextState: any) {
        if (!_.isNull(this.props.multiCompanyMetaData) && !_.isUndefined(this.props.multiCompanyMetaData) && !_.isUndefined(nextProps.multiCompanyMetaData)) {
            if ((this.props.multiCompanyMetaData.companyCode == nextProps.multiCompanyMetaData.companyCode)) {
                return true;
            }
            return false;
        }
        return false;
    }

    public openOriginLinkHrefFun() {
        const { multiCompanyMetaData, docHeaderSectionJson, menuCode } = this.props;
        let originDocUrlLink = '';
        const multiCompanyCode = multiCompanyMetaData.companyCode;
        if (docHeaderSectionJson.CatalystWatch && docHeaderSectionJson.CatalystWatch[multiCompanyCode]
            && docHeaderSectionJson.CatalystWatch[multiCompanyCode].originalDocUrl) {
            originDocUrlLink = HTML_RENDITION.addParentDocDataParam(docHeaderSectionJson.CatalystWatch[multiCompanyCode].originalDocUrl);
        }
        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.executeWindowOpenForEPFToken(originDocUrlLink);
            return;
        }
        const target = HTML_RENDITION.isAppInsideCVResearchUIiFrame() ? '_self' : '_blank';
        if (isEqual(target, '_blank') && !HTML_RENDITION.isCV2Link(originDocUrlLink)) {
            originDocUrlLink = HTML_RENDITION.getCVFrameUrl(menuCode, originDocUrlLink, 'all_research');
        }
        window.open(originDocUrlLink, target);
    }

    public openModal(e: any) {
        const { multiCompanyMetaData, catalystWatchData, sectionData } = this.props;
        const multiCompanyCode = multiCompanyMetaData.companyCode;
        let companyBookMarkId = 'bkm_CompanyName_' + multiCompanyCode.split('.').join('_');
        for (let i = 0; i < sectionData.documentContent?.length; i++) {
            if (sectionData.documentContent[i].companyName.id.toLowerCase() == companyBookMarkId.toLowerCase()) {
                companyBookMarkId = sectionData.documentContent[i].companyName.id;
                break;
            }
        }
        const companyCatalystWatchTable = $('#' + companyBookMarkId).parent().find('.CatalystWatch');
        if (companyCatalystWatchTable.length == 0 && _.isEmpty(catalystWatchData)) {
            this.props.loadCatalystWatchData();
        }
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.className === 'cw_scrollToLink') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            setTimeout(() => {
                this.setState({
                    modalStatus: true,
                });
            }, 500);
            e.target.className += " triggered_popup_flag";
            RSCH_HTML_TRACKING_CONFIG.trackRequestCatalystWatchClick();
        }
    }

    public scrollTo(e: any) {
        const { multiCompanyMetaData } = this.props;
        const multiCompanyCode = multiCompanyMetaData.companyCode;
        const companyBookMarkId = 'bkm_CompanyName_' + multiCompanyCode.split('.').join('_');
        const companyCatalystWatchTable = $('#' + companyBookMarkId).parent().find('.CatalystWatch').parents('[id^="CatalystWatch"]');
        // Important!!! Don't use react-redux mapStateToProps to get switchPageData in this file! Because when switchPageData change, it will cause reRender!
        const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
        if (_pageName !== 'mainPage') {
            switchPage('TocToMainPage');
        }
        if (this.props.initialData.showPDFDigidocViewer) {
            HTML_RENDITION.toggleToShowHTML(this.props.htmlPDFtoggleStatus);
        }
        if (e.target.className === 'cw_scrollToLink') {
            if (window.HTML_RENDITION.initialData.isFAVE) {
                const companyBookMarkClassName = 'catalystWatch_' + multiCompanyCode.split('.').join('_');
                HTML_RENDITION.bodyScrollToByClassName(companyBookMarkClassName);
                return;
            }
            const scrollEleName: any = companyCatalystWatchTable.attr('id');
            HTML_RENDITION.bodyScrollTo(scrollEleName);
        }
    }

    public getModalSource(template: string, ifShowScrollToLink: any = false) {
        const { multiCompanyMetaData, docHeaderSectionJson } = this.props;
        const multiCompanyCode = multiCompanyMetaData.companyCode;
        return (
            <div id="catalyst-watch-popup" className="catalyst-watch-popup">
                {docHeaderSectionJson.CatalystWatch && docHeaderSectionJson.CatalystWatch[multiCompanyCode]
                    && docHeaderSectionJson.CatalystWatch[multiCompanyCode].isOriginDoc == 'false' &&
                    <div id="catalyst-original-url">
                        <a tabIndex={0} role="link"
                           aria-label={docHeaderSectionJson.i18n.updated_original_link}
                           onClick={() => this.openOriginLinkHrefFun()}
                           onKeyPress={(e) => enterKeyPressed(e, this.openOriginLinkHrefFun.bind(this))}
                        >{docHeaderSectionJson.i18n.updated_original_link}</a>
                    </div>
                }
                <div className="catalyst-watch-table">
                    {template &&
                        <div dangerouslySetInnerHTML={{ __html: template }} />
                    }
                </div>
                <div className={"cw_scrollToLink_holder " + (ifShowScrollToLink ? 'show' : 'hide')}>
                    <span>{docHeaderSectionJson.i18n.figure_here_before}</span>
                    <a tabIndex={ifShowScrollToLink ? 0 : -1} role="link" aria-label={docHeaderSectionJson.i18n.figure_here} className="cw_scrollToLink"
                        onClick={(e) => this.scrollTo(e)}
                        onKeyPress={(e) => enterKeyPressed(e, this.scrollTo.bind(this, e))}
                    > {docHeaderSectionJson.i18n.figure_here} </a>
                    <span>{docHeaderSectionJson.i18n.figure_here_after}</span>
                </div>
            </div>);
    }

    public render() {
        const { multiCompanyMetaData, docHeaderSectionJson, catalystWatchData, sectionData} = this.props;
        const _modalStatus = this.state.modalStatus;
        let _modalSource = null;
        if (_modalStatus) {
            const multiCompanyCode = multiCompanyMetaData.companyCode;
            let companyBookMarkId = 'bkm_CompanyName_' + multiCompanyCode.split('.').join('_');
            for (let i = 0; i < sectionData.documentContent?.length; i++) {
                if (sectionData.documentContent[i].companyName.id.toLowerCase() == companyBookMarkId.toLowerCase()) {
                    companyBookMarkId = sectionData.documentContent[i].companyName.id;
                    break;
                }
            }

            let companyCatalystWatchTable = $('#' + companyBookMarkId).parent().find('.CatalystWatch');
            if (window.HTML_RENDITION.initialData.isFAVE){
                const cwContainerIndictor = '.catalystWatch_' + (multiCompanyCode.indexOf('.') > -1 ? multiCompanyCode.split('.').join('_') : multiCompanyCode);
                const $cwContainer = $(cwContainerIndictor).nextAll('.citiTable-template-part').eq(0);
                if ($cwContainer.find('table.CatalystWatch').length > 0) {
                    companyCatalystWatchTable = $cwContainer.find('table.CatalystWatch');
                }
            }
            let ifShowScrollToLink = false;
            let template1: string = '';
            let template2: string = '';
            if (companyCatalystWatchTable.length > 0 && window.HTML_RENDITION.initialData.enableSTView !== 'true') {                 // if body content has CW
                template1 = companyCatalystWatchTable[0].outerHTML;
                template2 = $(template1).addClass('CW_fromBody').css('border-width', '0').prop("outerHTML");
                ifShowScrollToLink = true;
                _modalSource = this.getModalSource(template2, ifShowScrollToLink);
            } else {
                let cw_table: string = '';
                if (!_.isEmpty(catalystWatchData)) {                    // if body content doesn't have CW, then use the content from json
                    const parsedCatalystWatchData = JSON.parse(catalystWatchData[multiCompanyCode]);
                    if (catalystWatchData[multiCompanyCode] && parsedCatalystWatchData.response
                        && parsedCatalystWatchData.response.data.GET_CATALYST_WATCH
                        && parsedCatalystWatchData.response.data.GET_CATALYST_WATCH.data[0]) {
                        cw_table = parsedCatalystWatchData.response.data.GET_CATALYST_WATCH.data[0].htmlText;
                        cw_table = $(cw_table).find('tr').first().addClass('first').parents('table')[0].outerHTML;
                        cw_table = $(cw_table).find('tr').last().addClass('last').parents('table')[0].outerHTML;
                    } else if (window.HTML_RENDITION.initialData.isFAVE && parsedCatalystWatchData.htmlText) {
                        cw_table = parsedCatalystWatchData.htmlText;
                        try {
                            const reg = /^<table/g;
                            if (!reg.test(cw_table)) {
                                cw_table = Base64.decode(cw_table);
                            }
                            cw_table = $(cw_table).find('tr').first().addClass('first').parents('table')[0].outerHTML;
                            cw_table = $(cw_table).find('tr').last().addClass('last').parents('table')[0].outerHTML;
                        } catch (e) {
                            cw_table = '<div>The data structure or type has some issue, and can\'t render the table.</div>';
                        }
                    } else {
                        cw_table = '<div>No data available.</div>';
                    }
                    _modalSource = this.getModalSource(cw_table);
                }
            }
        }
        const title = docHeaderSectionJson.CatalystWatch[multiCompanyMetaData.companyCode]?.title;
        const cwStvTitle = getCwStvTitle(title);
        return (
            <div role="dialog" className="catalystWatch financials" onClick={(e) => this.openModal(e)}
                 onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                {_modalStatus && _modalSource &&
                    <ModalPopup classList={'modal-catalyst'}>
                        <NormalScreenPopup titleSource={cwStvTitle} bodySource={_modalSource} modalWindowStyle={{width: '800px', height: 'auto'}}/>
                    </ModalPopup>}
                    <span className='icon-svg-parent'>
                        <span className="icon-svg icon-catalyst-watch icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.catalystWatch} />
                    </span>
                <a tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.catalystWatch} id="requestCatalyst_watch" className="x-rsch-hyperlink">{cwStvTitle}</a>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
        catalystWatchData: state.asyncStateReducer.catalystWatchData,
        sectionData: state.asyncStateReducer.sectionData,
        htmlPDFtoggleStatus: state.commonStateReducer.htmlPDFtoggleStatus,
        menuCode: state.commonStateReducer.menuCode,
    };
};

const mapDispatchToProps = (dispatch: (any)) => ({
    loadCatalystWatchData: () => dispatch(asyncStateAction.fetchCatalystWatch(environmentService.getJsonPath(servicesConfig.GET_CATALYST_WATCH))),
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiCompanyCatalystWatch);
